module.exports = __webpack_public_path__ + "static/img/app_web.a62ab81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/code/app_web.png
// module id = gr8H
// module chunks = 11